import styled from "@styled";

export const SliderWrap = styled.div`
  position: relative;

`;